import { Component, OnInit } from '@angular/core';
import { cerrarModalCargando } from '@cf-v5-workspace/utils';

@Component({
  selector: 'yeminus-error-ruta',
  templateUrl: './error-ruta.component.html',
  styleUrls: ['./error-ruta.component.css']
})
export class ErrorRutaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    cerrarModalCargando();
  }

}
